export default __webpack_public_path__ + "static/media/interpreting_carousel_5.110b4d5a.jpg";